import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function MindmapChemTopics() {
  return (
    <>

      <AllSubjectTopics  subject="chemistry" type="mindmap" />


    </>
  );
}

export default MindmapChemTopics;